import { createContext, ReactNode, useEffect, useState } from "react";
import { Helpers } from "../helpers/helpers";
import { IQuestion } from "../types";

interface ISelectedItems {
    selectedQns: IQuestion[];
    addToSelected: (qns: IQuestion[]) => void;
    removeFromSelected: (qn: IQuestion) => void;
    clearSelected: () => void;
    selectedQnsOutOf: number;
}

interface SelectedItemsProviderProps {
    children: ReactNode;
}

export const SelectedItemsContext = createContext<ISelectedItems| undefined>(undefined);

export const SelectedItemsProvider = (props: SelectedItemsProviderProps) => {

    const [selectedQnsOutOfValue, setSelectedQnsOutOfValue] = useState<number>(0);
    const [selectedQns, setSelectedQns] = useState<IQuestion[]>([]);

    useEffect(() => {
        setSelectedQnsOutOfValue(Helpers.sum(selectedQns.map(i => i.num_marks)));
    }, [selectedQns.length])

    return (
        <SelectedItemsContext value={{
            selectedQns,
            addToSelected: (qns: IQuestion[]) => {
                let ret = [...selectedQns];
                for (let qn of qns) {
                    if (ret.indexOf(qn) === -1) {
                        ret.push(qn);
                    }
                }
                setSelectedQns(ret);
            },
            removeFromSelected: (qn: IQuestion) => {
                let ret = [];
                for (let member of selectedQns) {
                    if (qn !== member) {
                        ret.push(member);
                    }
                }
                setSelectedQns(ret);
            },
            clearSelected: () => {
                setSelectedQns([]);
            },
            selectedQnsOutOf: selectedQnsOutOfValue

        }}>
            {props.children}
        </SelectedItemsContext>
    )

}